<template>
  <router-view></router-view>
</template>
<script>
import RegisterStoreModule from '@/mixins/RegisterStoreModule'
import ticketStore from './store.js'

export default {
  name: 'ticket',
  mixins: [RegisterStoreModule],
  created() {
    this.registerStoreModule('ticket', ticketStore)
  },
}
</script>
